import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const QOROS_CFCG_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Intake",
    documentLabel: "Intake",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.INTAKE,
    group: "qoros-cfcg",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Referral",
    documentLabel: "Referral",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.REFERRAL,
    group: "qoros-cfcg",
  },
  [Classification.REFERER_INFORMATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Referrer Information",
    documentLabel: "Referrer Information",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.REFERER_INFORMATION,
    group: "qoros-cfcg",
  },
  [Classification.RESPONSE_TO_VH_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Response to VH Request",
    documentLabel: "Response to VH Request",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.RESPONSE_TO_VH_REQUEST,
    group: "qoros-cfcg",
  },
} as const;
